import { Modal } from '@zambezi/sdk/modal';
import { useCase } from 'hooks/useCase';
import { t } from 'i18next';
import { useParams } from 'react-router-dom';
import { formatCurrency } from '@hbo/ui-servicing-react-components';
import { formatAddress, formatDate, formatDateTime } from 'utils';

interface ValuationModalProps {
  onClose: () => void;
}

const ValuationModal: React.FC<ValuationModalProps> = ({ onClose }: ValuationModalProps) => {
  const { data } = useCase();

  return (
    <Modal
      className="modal-large"
      confirm="Close"
      title="Valuation"
      isClosable
      onConfirm={onClose}
      onCancel={onClose}
      open
    >
      <h3 className="zb-heading3">Valuation information</h3>
      <table className="case-details">
        <tbody>
          {[
            [
              'Valuation Instruction Date',
              formatDate(
                data?.mortgageSummary?.milestones?.valuation?.valuationInformation
                  ?.valuationInstructionDate
              )
            ],
            [
              'Valuation Date',
              formatDate(
                data?.mortgageSummary?.milestones?.valuation?.valuationInformation?.valuationDate
              )
            ],
            [
              'Valuation Received',
              formatDate(
                data?.mortgageSummary?.milestones?.valuation?.valuationInformation
                  ?.valuationReceived
              )
            ],
            [
              'Valuation Accepted',
              formatDate(
                data?.mortgageSummary?.milestones?.valuation?.valuationInformation
                  ?.valuationAccepted
              )
            ],
            [
              'Valuation Fee Amount',
              formatCurrency(
                data?.mortgageSummary?.milestones?.valuation?.valuationInformation
                  ?.valuationFeeAmount
              )
            ]
          ].map(([label, value], index) => (
            <tr key={`valuation-${index}`}>
              <th>{label}</th>
              <td>{value || '-'}</td>
            </tr>
          ))}
        </tbody>
      </table>

      <h3 className="zb-heading3">Property information</h3>
      <table className="case-details">
        <tbody>
          {[
            [
              'Property To Be Mortgaged',
              formatAddress(
                data?.mortgageSummary?.milestones?.valuation?.propertyInformation?.addressInfo,
                true
              )
            ],
            [
              'Property Type',
              data?.mortgageSummary?.milestones?.valuation?.propertyInformation?.propertyType
            ],
            [
              'Year of Build',
              data?.mortgageSummary?.milestones?.valuation?.propertyInformation?.yearOfBuild
            ],
            [
              'Valuation Type',
              data?.mortgageSummary?.milestones?.valuation?.propertyInformation?.valuationType
            ],
            [
              'Confirmed Valuation Amount',
              formatCurrency(
                data?.mortgageSummary?.milestones?.valuation?.propertyInformation
                  ?.confirmValuationAmount
              )
            ]
          ].map(([label, value], index) => (
            <tr key={`property-${index}`}>
              <th>{label}</th>
              <td>{value || '-'}</td>
            </tr>
          ))}
        </tbody>
      </table>

      {data?.mortgageSummary?.milestones?.valuation?.updates.length ? (
        <>
          <h3 className="zb-heading3">Updates</h3>
          <div className="zb-has-scrollbar" style={{ maxHeight: 200, overflowY: 'scroll' }}>
            {data?.mortgageSummary.milestones.valuation.updates.map((update, index) => (
              <div className="record-entry" key={`update-${index}`}>
                <div className="record-entry-content">
                  <p>{update.description}</p>
                </div>
                <div className="record-entry-meta">
                  <p>{formatDateTime(update.dateTime)}</p>
                </div>
              </div>
            ))}
          </div>
        </>
      ) : null}

      {data?.mortgageSummary?.milestones?.valuation?.valuationHistory.updates?.length ? (
        <>
          <h3 className="zb-heading3">{t('case.valuationModal.history')}</h3>
          <div className="zb-has-scrollbar" style={{ maxHeight: 200, overflowY: 'scroll' }}>
            {data?.mortgageSummary.milestones.valuation.valuationHistory.updates.map(
              (update, index) => (
                <div className="record-entry" key={`update-${index}`}>
                  <div className="record-entry-content">
                    <p>{update.description}</p>
                  </div>
                  <div className="record-entry-meta">
                    <p>{formatDateTime(update.dateTime)}</p>
                  </div>
                </div>
              )
            )}
          </div>
        </>
      ) : null}
    </Modal>
  );
};

export default ValuationModal;
